let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("glWzP"), load("adfUx"), load("8F6ik")]).then(() => parcelRequire('f8JZq'));